import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "@appcore/service";

@Component({
  templateUrl: "logout.component.html"
})
export class LogoutComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  _organizations = [];
  organizationsListModel: string[] = [];

  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  ngOnInit() {
    this.authenticationService.logout().subscribe(data => {
      if (data == null) {
        this.router.navigate(["/"]);
      }
    });
  }
}
